import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { DOCUMENT_TYPES } from '../../constants/documents.constants';

const { Option } = Select;

const DocumentType = () => {
    const { t } = useTranslation('forms', { keyPrefix: 'FORMS.INPUTS' });
    const { t: tr } = useTranslation('forms', { keyPrefix: 'FORMS.RULES' });

    const RULES = [{ required: true, message: tr('REQUIRED_FIELD') }];

    return (
        <Form.Item
            label={t('DOCUMENT_TYPE')}
            name="documentType"
            initialValue="BOOK"
            rules={RULES}
        >
            <Select
                placeholder={t('DOCUMENT_TYPE_PLACEHOLDER')}
            >
                {
                    DOCUMENT_TYPES.map((type, index) => (
                        <Option value={type} key={index}>
                            {t(`DOCUMENT_TYPES.${type}`)}
                        </Option>
                    ))
                }
            </Select>
        </Form.Item>
    );
};

export default DocumentType;
